import React from 'react'
import { X } from 'lucide-react'
import ReliableButton from './ReliableButton'
import styles from './preview-cancel-button.module.scss'

type Props = {
    title?: string
    ariaLabel?: string
    testId?: string
    onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void
}

export default function PreviewCancelButton({
    title = 'Cancel',
    ariaLabel = 'Cancel',
    testId,
    onClick,
}: Props) {
    const handleClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
        try {
            ev.stopPropagation()
        } catch {}
        onClick && onClick(ev)
    }
    return (
        <div className={styles.previewCancelButtonContainer}>
            <ReliableButton
                className={styles.previewCancelButtonComp}
                onClick={handleClick}
                aria-label={ariaLabel}
                title={title}
                data-testid={testId}
            >
                <X />
            </ReliableButton>
        </div>
    )
}
